import React, { useState } from "react";
import { Phone, Loader2, LogOut } from "lucide-react";
import http from "@/api";
import { useApp } from "@/context";
import PhoneField from "@/components/PhoneField";

/* بوابة رقم الجوال الإلزامية: تظهر بعد تسجيل الدخول بأي طريقة
   (إيميل / Google / Apple) إذا لم يكن للحساب رقم جوال مسجّل.
   لا يمكن إغلاقها إلا بحفظ رقم صحيح أو تسجيل الخروج. */
export default function PhoneGateModal() {
  const { user, setUser, authReady, lang, logout } = useApp();
  const [phone, setPhone] = useState("+974");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const ar = lang === "ar";

  if (!authReady || !user || user.phone) return null;

  const save = async (e) => {
    e?.preventDefault();
    const digits = phone.replace(/[^0-9]/g, "");
    if (digits.length < 11) {
      setErr(ar ? "أدخل رقم جوال صحيح" : "Enter a valid mobile number");
      return;
    }
    setErr(""); setBusy(true);
    try {
      const { data } = await http.put("/auth/me/phone", { phone });
      setUser({ ...user, phone: data.phone });
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === "string" ? d : (ar ? "تعذّر الحفظ، حاول مجدداً" : "Could not save, try again"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4"
         style={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(6px)" }}
         data-testid="phone-gate-modal">
      <div className="w-full max-w-sm rounded-2xl bg-white shadow-2xl p-6" dir={ar ? "rtl" : "ltr"}>
        <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3"
             style={{ background: "rgba(176,141,77,0.14)", color: "#8a6c33", marginInline: "auto" }}>
          <Phone size={22} />
        </div>
        <h2 className="text-lg font-bold text-center mb-1">
          {ar ? "أضِف رقم جوالك" : "Add your mobile number"}
        </h2>
        <p className="text-sm text-center opacity-70 mb-4 leading-relaxed">
          {ar
            ? "رقم الجوال إلزامي لإكمال استخدام حسابك — نستخدمه للتواصل معك بخصوص طلباتك."
            : "A mobile number is required to continue — we use it to contact you about your orders."}
        </p>
        <form onSubmit={save} className="space-y-3">
          <PhoneField value={phone} onChange={setPhone} lang={lang} testId="phone-gate" />
          {err && <div className="text-sm text-red-500 text-center" data-testid="phone-gate-error">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="phone-gate-save-btn">
            {busy ? <Loader2 className="animate-spin" size={16} /> : null}
            {ar ? "حفظ ومتابعة" : "Save & continue"}
          </button>
        </form>
        <button type="button" onClick={logout}
                className="mt-3 w-full text-xs opacity-60 hover:opacity-100 inline-flex items-center justify-center gap-1"
                data-testid="phone-gate-logout-btn">
          <LogOut size={12} />
          {ar ? "تسجيل الخروج" : "Log out"}
        </button>
      </div>
    </div>
  );
}
